import type { IconName } from '../components/Icon'

export interface ComingSoonContent {
  title: string
  icon: IconName
  summary: string
  bullets: string[]
  dependency?: string
}

// Route path → placeholder content. Each becomes a real route in the Shell so
// deep links, nav highlighting and later replacement are trivial.
export const COMING_SOON: Record<string, ComingSoonContent> = {
  '/skills': {
    title: 'Skills',
    icon: 'spark',
    summary:
      'Package multi-step tool workflows into reusable skills your agents can discover and call like a single tool.',
    bullets: [
      'Compose tools from any toolkit into one skill',
      'Version, test and roll back skills',
      'Expose skills over MCP alongside toolkits',
    ],
  },
  '/users': {
    title: 'Users',
    icon: 'users',
    summary:
      'See the end users of your app who have connected accounts through Symone, what they have connected, and their recent activity.',
    bullets: [
      'Per-user connected accounts and status',
      'Revoke or re-authorize a user’s connections',
      'Filter logs and sessions by user',
    ],
    dependency: 'Waiting on the external end-user data model in the gateway.',
  },
  '/auth-configs': {
    title: 'Auth Configs',
    icon: 'shield',
    summary:
      'Bring your own OAuth apps and credentials per workspace, so connection screens show your brand and your scopes.',
    bullets: [
      'Custom OAuth client ID and secret per toolkit',
      'Choose scopes per auth config',
      'Use multiple configs for the same toolkit',
    ],
    dependency: 'Waiting on per-workspace auth configs in the gateway.',
  },
  '/sandbox': {
    title: 'Sandbox',
    icon: 'box',
    summary:
      'An isolated execution environment for code-execution mode: run agent-written code next to your tools without touching production data.',
    bullets: [
      'Ephemeral, network-restricted runtimes',
      'Mount tool results as files',
      'Resource and time limits per run',
    ],
  },
}
